import React from 'react';

import { Typography, CircularButton } from '@hpi-sox/hpstellar-core';

import './sticky-card.less';

export default function StickyCard({ id, title, fps, imgUrl, onClick, onRemove, index, slim = false, isFull = false }) {
    if (!title) {
        return (
            <div className="stickyCardContainer add" onClick={() => onClick(id)}>
                <CircularButton className="stickyButton" icon="plus" aria-label="Add game" />
                <Typography className="addGame" variant="boldXS">
                    {slim ? 'ADD' : 'ADD GAME'}
                </Typography>
            </div>
        );
    }

    return (
        <div className={`stickyCardContainer${slim ? ' slim' : ''}${imgUrl ? '' : ' noImg'}`}>
            <div className="gameImg" onClick={() => onRemove(index)}>
                {imgUrl ? <img src={imgUrl} /> : <div className="fpsImgGradient" />}
                <div className="gameAction">
                    <CircularButton className="removeButton" icon="cross" size="small" useTransparentBg />
                    <Typography className="removeGame" variant="boldXS">
                        {isFull ? 'CHANGE' : 'REMOVE'}
                    </Typography>
                </div>
            </div>
            <Typography className="gameTitle" variant="boldXS" style={{ color: '#2C3038' }}>
                {title}
            </Typography>
            <Typography className="fps" variant="bodyXS" style={{ color: '#5A5A5A' }}>
                {fps}
            </Typography>
        </div>
    );
}
